import { render, staticRenderFns } from "./MatterSupremeCourtList.vue?vue&type=template&id=44aaf46b&"
import script from "./MatterSupremeCourtList.vue?vue&type=script&lang=js&"
export * from "./MatterSupremeCourtList.vue?vue&type=script&lang=js&"
import style0 from "./MatterSupremeCourtList.vue?vue&type=style&index=0&id=44aaf46b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports